import FrontendRoutesBase from './FrontendRoutesBase';
import PATH_PARAM, { PAGE_TYPE, PATH_PARAM_DASHBOARD, PATH_PARAM_TOKEN } from '../PATH_PARAM';
import IFrontendRoutes from './IFrontendRoutes';
import { MODEL_PERMISSION } from 'configs/permissions/modelPermissions';

export default class ModelsDirectoryRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  public root = this.getDBPath(PATH_PARAM_DASHBOARD.modelsDirectory.root);
  public brand: BrandRoutes;
  public legalEntity: LegalEntityRoutes;
  public department: DepartmentRoutes;
  public employee: EmployeeRoutes;
  public technician: TechnicianRoutes;
  public region: RegionRoutes;
  public technicianTeam: TechnicianTeamRoutes;
  public shop: ShopRoutes;
  public documentTemplate: DocumentTemplatesRoutes;
  public servicePackage: ServicePackageRoutes;
  public service: ServiceCatalogRoutes;

  constructor() {
    super();
    this.brand = new BrandRoutes(this);
    this.legalEntity = new LegalEntityRoutes(this);
    this.department = new DepartmentRoutes(this);
    this.employee = new EmployeeRoutes(this);
    this.technician = new TechnicianRoutes(this);
    this.region = new RegionRoutes(this);
    this.shop = new ShopRoutes(this);
    this.technicianTeam = new TechnicianTeamRoutes(this);
    this.documentTemplate = new DocumentTemplatesRoutes(this);
    this.servicePackage = new ServicePackageRoutes(this);
    this.service = new ServiceCatalogRoutes();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_p, permissions, translate) => {
    return permissions.can(MODEL_PERMISSION.CAN_READ_ENTERPRISE_LIST)
      ? [{ name: translate('menus.main.modelsDirectory'), href: this.getListPath() }]
      : [];
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (
    p,
    pm,
    t,
    n
  ) => {
    const breadcrumbs = this.getInfoBc(p, pm, t);
    breadcrumbs.push({ name: n.enterpriseName, href: this.getInfoPath(p) });
    return breadcrumbs;
  };

  getListBc = this.getEmptyBreadcrumbs;
  getListPath = () => this.getDBPath(PATH_PARAM_DASHBOARD.modelsDirectory.root, PAGE_TYPE.list);

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(PATH_PARAM_DASHBOARD.modelsDirectory.root, PAGE_TYPE.info);

  getAddBc = this.getInstanceBc;
  getAddPath = () => this.getDBPath(PATH_PARAM_DASHBOARD.modelsDirectory.root, PAGE_TYPE.new, PAGE_TYPE.add);

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(PATH_PARAM_DASHBOARD.modelsDirectory.root, PAGE_TYPE.edit);
  getTechnicianSettingsEditBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (
    p,
    pm,
    t,
    n
  ) => {
    const breadcrumbs = this.getInstanceChildBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.technician.getListPath(p));
    return breadcrumbs;
  };
  getTechnicianSettingsEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicianSettings,
      PAGE_TYPE.edit
    );
}

class BrandRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private parent: ModelsDirectoryRoutes) {
    super();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.parent.getInstanceChildBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName' | 'brandName'> =
    (p, pm, t, n) => {
      const breadcrumbs = this.getInstanceBc(p, pm, t, n);
      breadcrumbs.push({ name: n.brandName, href: this.getInfoPath(p) });
      return breadcrumbs;
    };

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = () =>
    this.getDBPath(PATH_PARAM_DASHBOARD.modelsDirectory.root, PATH_PARAM_DASHBOARD.modelsDirectory.brands, PAGE_TYPE.list);

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.brands,
      params.brandId,
      PAGE_TYPE.info
    );

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.brands,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.brands,
      params.brandId,
      PAGE_TYPE.edit
    );

  getClientsAppInfoBc = this.getInstanceBc;
  getClientsAppInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.brands,
      params.brandId,
      PATH_PARAM_DASHBOARD.brand.clientsApp,
      PAGE_TYPE.info
    );

  getClientsAppEditBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName' | 'brandName'> =
    (p, pm, t, n) => {
      const breadcrumbs = this.getEditBc(p, pm, t, n);
      this.setLastBcLink(breadcrumbs, this.getClientsAppInfoPath(p));
      return breadcrumbs;
    };
  getClientsAppEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.brands,
      params.brandId,
      PATH_PARAM_DASHBOARD.brand.clientsApp,
      PAGE_TYPE.edit
    );
}

class ShopRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private parent: ModelsDirectoryRoutes) {
    super();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.parent.getInstanceChildBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName' | 'shopName'> = (
    p,
    pm,
    t,
    n
  ) => {
    const breadcrumbs = this.getInstanceBc(p, pm, t, n);
    breadcrumbs.push({ name: n.shopName, href: this.getInfoPath(p) });
    return breadcrumbs;
  };

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.shops,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.shops,
      params.shopId,
      PAGE_TYPE.info
    );

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.shops,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.shops,
      params.shopId,
      PAGE_TYPE.edit
    );
}

class DocumentTemplatesRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private parent: ModelsDirectoryRoutes) {
    super();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.parent.getInstanceChildBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'documentTemplate'
  > = (p, pm, t, n) => {
    const breadcrumbs = this.getInstanceBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.documentTemplates,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.documentTemplates,
      params.documentTemplateId,
      PAGE_TYPE.info
    );

  getAddBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.parent.getInstanceChildBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.documentTemplates,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getAddBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.documentTemplates,
      params.documentTemplateId,
      PAGE_TYPE.edit
    );
}

class LegalEntityRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private parent: ModelsDirectoryRoutes) {
    super();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.parent.getEditBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'legalEntityName'
  > = (p, pm, t, n) => {
    return this.getAddBc(p, pm, t, n).concat([{ name: n.legalEntityName, href: this.getInfoPath(p) }]);
  };

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.legalEntities,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.legalEntities,
      params.legalEntityId,
      PAGE_TYPE.info
    );

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.legalEntities,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.legalEntities,
      params.legalEntityId,
      PAGE_TYPE.edit
    );
}

class DepartmentRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private parent: ModelsDirectoryRoutes) {
    super();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.parent.getEditBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'departmentName'
  > = (p, pm, t, n) => {
    return this.getAddBc(p, pm, t, n).concat([{ name: n.departmentName, href: this.getInfoPath(p) }]);
  };

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.departments,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.departments,
      params.departmentId,
      PAGE_TYPE.info
    );

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.departments,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.departments,
      params.departmentId,
      PAGE_TYPE.edit
    );
}

class EmployeeRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private modelsDirectory: ModelsDirectoryRoutes) {
    super();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.modelsDirectory.getEditBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName' | 'userName'> = (
    p,
    pm,
    t,
    n
  ) => {
    return this.getAddBc(p, pm, t, n).concat([{ name: n.userName, href: this.getInfoPath(p) }]);
  };

  getListBc = this.modelsDirectory.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.employees,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.employees,
      params.userId,
      PAGE_TYPE.info
    );

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.employees,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.employees,
      params.userId,
      PAGE_TYPE.edit
    );

  getNotificationsInfoBc = this.getInstanceBc;
  getNotificationsInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.employees,
      params.userId,
      PATH_PARAM_DASHBOARD.user.notifications,
      PAGE_TYPE.info
    );

  getNotificationsEditBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'userName'
  > = (p, pm, t, n) => {
    return this.getAddBc(p, pm, t, n).concat([{ name: n.userName, href: this.getNotificationsInfoPath(p) }]);
  };
  getNotificationsEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.employees,
      params.userId,
      PATH_PARAM_DASHBOARD.user.notifications,
      PAGE_TYPE.edit
    );
}

class TechnicianRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private modelsDirectory: ModelsDirectoryRoutes) {
    super();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.modelsDirectory.getEditBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName' | 'userName'> = (
    p,
    pm,
    t,
    n
  ) => {
    return this.getAddBc(p, pm, t, n).concat([{ name: n.userName, href: this.getInfoPath(p) }]);
  };

  getListBc = this.modelsDirectory.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      params.technicianId,
      PAGE_TYPE.info
    );

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      params.technicianId,
      PAGE_TYPE.edit
    );

  getNotificationsInfoBc = this.getInstanceBc;
  getNotificationsInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      params.technicianId,
      PATH_PARAM_DASHBOARD.user.notifications,
      PAGE_TYPE.info
    );

  getNotificationsEditBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'userName'
  > = (p, pm, t, n) => {
    return this.getAddBc(p, pm, t, n).concat([{ name: n.userName, href: this.getNotificationsInfoPath(p) }]);
  };
  getNotificationsEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      params.technicianId,
      PATH_PARAM_DASHBOARD.user.notifications,
      PAGE_TYPE.edit
    );

  getLegalEntityInfoBc = this.getInstanceBc;
  getLegalEntityInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      params.technicianId,
      PATH_PARAM_DASHBOARD.enterpriseEmployee.legalEntity,
      PAGE_TYPE.info
    );

  getLegalEntityEditBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'technicianName'
  > = (p, pm, t, n) => {
    return this.getInstanceBc(p, pm, t, n).concat([{ name: n.technicianName, href: this.getLegalEntityInfoPath(p) }]);
  };
  getLegalEntityEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      params.technicianId,
      PATH_PARAM_DASHBOARD.enterpriseEmployee.legalEntity,
      PAGE_TYPE.edit
    );

  getReviewsBc = this.getInstanceBc;
  getReviewsPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      params.technicianId,
      PATH_PARAM_DASHBOARD.scEmployee.reviews
    );

  getRegionServiceListBc = this.getInstanceBc;
  getRegionServiceListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      params.technicianId,
      PATH_PARAM_DASHBOARD.scEmployee.regionServices,
      PAGE_TYPE.list
    );

  getRegionServiceEditBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'technicianName'
  > = (p, pm, t, n) => {
    return this.getInstanceBc(p, pm, t, n).concat([{ name: n.technicianName, href: this.getRegionServiceListPath(p) }]);
  };
  getRegionServiceEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
      params.technicianId,
      PATH_PARAM_DASHBOARD.scEmployee.regionServices,
      PAGE_TYPE.edit
    );
}

class RegionRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private parent: ModelsDirectoryRoutes) {
    super();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.parent.getInstanceChildBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName' | 'regionName'> =
    (p, pm, t, n) => {
      const breadcrumbs = this.getInstanceBc(p, pm, t, n);
      breadcrumbs.push({ name: n.regionName, href: this.getInfoPath(p) });
      return breadcrumbs;
    };

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.regions,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.regions,
      params.regionId,
      PAGE_TYPE.info
    );

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.regions,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.regions,
      params.regionId,
      PAGE_TYPE.edit
    );
}

class TechnicianTeamRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private parent: ModelsDirectoryRoutes) {
    super();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.parent.getInstanceChildBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'technicianTeamName'
  > = (p, pm, t, n) => {
    const breadcrumbs = this.getInstanceBc(p, pm, t, n);
    breadcrumbs.push({ name: n.technicianTeamName, href: this.getInfoPath(p) });
    return breadcrumbs;
  };

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicianTeams,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicianTeams,
      params.technicianTeamId,
      PAGE_TYPE.info
    );

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicianTeams,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.technicianTeams,
      params.technicianTeamId,
      PAGE_TYPE.edit
    );
}

class ServicePackageRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private parent: ModelsDirectoryRoutes) {
    super();
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (p, pm, t, n) => {
    const breadcrumbs = this.parent.getInstanceChildBc(p, pm, t, n);
    this.setLastBcLink(breadcrumbs, this.getListPath(p));
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'servicePackageName'
  > = (p, pm, t, n) => {
    const breadcrumbs = this.getInstanceBc(p, pm, t, n);
    breadcrumbs.push({ name: n.servicePackageName, href: this.getInfoPath(p) });
    return breadcrumbs;
  };

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.servicePackages,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.servicePackages,
      params.servicePackageId,
      PAGE_TYPE.info
    );

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.servicePackages,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM_DASHBOARD.modelsDirectory.root,

      PATH_PARAM_DASHBOARD.modelsDirectory.servicePackages,
      params.servicePackageId,
      PAGE_TYPE.edit
    );
}

class ServiceCatalogRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  public root = this.getDBPath(PATH_PARAM.dashboard.modelsDirectory.services);
  public enterprise: EnterpriseRoutes;
  public categoryGroup: ServiceCategoryGroupRoutes;
  public category: ServiceCategoryRoutes;
  public service: ServiceRoutes;

  getInstanceBc = this.getEmptyBreadcrumbs;
  getInstanceChildBc = this.getEmptyBreadcrumbs;

  constructor() {
    super();
    this.enterprise = new EnterpriseRoutes();
    this.categoryGroup = new ServiceCategoryGroupRoutes(this.enterprise);
    this.category = new ServiceCategoryRoutes(this.categoryGroup);
    this.service = new ServiceRoutes(this.category);
  }
}

class EnterpriseRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  public child: ServiceCategoryGroupRoutes | null = null;

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params, permissions, translate) => {
    const canAccessEnterpriseListPage = permissions.can(MODEL_PERMISSION.CAN_READ_ENTERPRISE_LIST);
    return canAccessEnterpriseListPage ? [{ name: translate('menus.main.services'), href: this.getListPath(params) }] : [];
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (
    params,
    permissions,
    translate,
    names
  ) => {
    const breadcrumbs = this.getInstanceBc(params, permissions, translate);
    breadcrumbs.push({ name: names.enterpriseName, href: this.getInfoPath(params) });
    return breadcrumbs;
  };

  getListBc = this.getEmptyBreadcrumbs;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,

      PATH_PARAM.dashboard.modelsDirectory.services,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.child ? this.child.getListPath(params) : '#';
}

class ServiceCategoryGroupRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  public child: ServiceCategoryRoutes | null = null;
  constructor(private parent: EnterpriseRoutes) {
    super();
    parent.child = this;
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.modelsDirectory, 'enterpriseName'> = (
    params,
    permissions,
    translate,
    names
  ) => {
    return this.parent.getInstanceChildBc(params, permissions, translate, names);
  };

  getInstanceChildBc = this.getInstanceBc;

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,

      PATH_PARAM.dashboard.modelsDirectory.services,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.child ? this.child.getListPath(params) : '#';

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (_params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,

      PATH_PARAM.dashboard.modelsDirectory.services,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,

      PATH_PARAM.dashboard.modelsDirectory.services,
      params.serviceCategoryGroupId,
      PAGE_TYPE.edit
    );
}

class ServiceCategoryRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  public child: ServiceRoutes | null = null;
  constructor(private parent: ServiceCategoryGroupRoutes) {
    super();
    parent.child = this;
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'serviceCategoryGroupName'
  > = (params, permissions, translate, names) => {
    const breadcrumbs = this.parent.getInstanceChildBc(params, permissions, translate, names);
    breadcrumbs.push({ name: names.serviceCategoryGroupName, href: this.parent.getInfoPath(params) });
    return breadcrumbs;
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'serviceCategoryGroupName' | 'serviceCategoryName'
  > = (params, permissions, translate, names) => {
    const breadcrumbs = this.getInstanceBc(params, permissions, translate, names);
    breadcrumbs.push({ name: names.serviceCategoryName, href: this.getInfoPath(params) });
    return breadcrumbs;
  };

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,

      PATH_PARAM.dashboard.modelsDirectory.services,
      params.serviceCategoryGroupId,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.child ? this.child.getListPath(params) : '#';

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,

      PATH_PARAM.dashboard.modelsDirectory.services,
      params.serviceCategoryGroupId,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,

      PATH_PARAM.dashboard.modelsDirectory.services,
      params.serviceCategoryGroupId,
      params.serviceCategoryId,
      PAGE_TYPE.edit
    );
}

class ServiceRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  constructor(private parent: ServiceCategoryRoutes) {
    super();
    parent.child = this;
  }

  getInstanceBc = this.parent.getInstanceChildBc;

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<
    typeof PATH_PARAM_TOKEN.modelsDirectory,
    'enterpriseName' | 'serviceCategoryGroupName' | 'serviceCategoryName' | 'serviceName'
  > = (params, permissions, translate, names) => {
    const breadcrumbs = this.getInstanceBc(params, permissions, translate, names);
    breadcrumbs.push({ name: names.serviceName, href: this.getInfoPath(params) });
    return breadcrumbs;
  };

  getListBc = this.parent.getInstanceBc;
  getListPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,

      PATH_PARAM.dashboard.modelsDirectory.services,
      params.serviceCategoryGroupId,
      params.serviceCategoryId,
      PAGE_TYPE.list
    );

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,
      PATH_PARAM.dashboard.modelsDirectory.services,
      params.serviceCategoryGroupId,
      params.serviceCategoryId,
      params.serviceId,
      PAGE_TYPE.info
    );

  getAddBc = this.getInstanceBc;
  getAddPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,
      PATH_PARAM.dashboard.modelsDirectory.services,
      params.serviceCategoryGroupId,
      params.serviceCategoryId,
      PAGE_TYPE.new,
      PAGE_TYPE.add
    );

  getEditBc = this.getInstanceChildBc;
  getEditPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.modelsDirectory> = (params) =>
    this.getDBPath(
      PATH_PARAM.dashboard.modelsDirectory.root,
      PATH_PARAM.dashboard.modelsDirectory.services,
      params.serviceCategoryGroupId,
      params.serviceCategoryId,
      params.serviceId,
      PAGE_TYPE.edit
    );
}
